/**
 * 탈퇴 요청 관리 헬퍼 함수 및 상수
 */
import { formatDateArray } from '../../shared/lib/dateFormatterHelpers';
import { formatCurrency } from '@/shared/utils/formatter';
import {
    WithdrawRequestDto,
    GetWithdrawRequestListResponseDto,
    WithdrawRequest,
} from '../types/userWithdraw.types';

// ======== 타입 ========

export interface FilterState {
    riderName: string;
    suppName: string;
    contStatus: string;
    withdrawalStatusCd: string;
}

// ======== 상수 ========

export const INITIAL_FILTERS: FilterState = {
    riderName: '',
    suppName: '',
    contStatus: '',
    withdrawalStatusCd: '',
};

// ======== 내부 헬퍼 ========

const formatDateOnly = (dateArray: number[] | null): string => {
    if (!dateArray || dateArray.length < 3) return '-';
    const [year, month, day] = dateArray;
    return `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
};

const formatAmount = (amount: number | null): string => {
    if (amount === null || amount === undefined) return '-';
    return formatCurrency(amount);
};

// ======== DTO 변환 ========

export const withdrawRequestFromDto = (dto: WithdrawRequestDto, index: number): WithdrawRequest => {
    const withdrawalReqDateTime = formatDateArray(dto.memberWithdrawalReqDate);
    const withdrawalReqDate = formatDateOnly(dto.memberWithdrawalReqDate);

    return {
        no: index + 1,
        riderId: dto.riderId || '',
        riderName: dto.riderName || '',
        suppId: dto.suppId || '',
        suppName: dto.suppName || '',
        contStatus: dto.contStatus || '',
        contStatusName: dto.contStatusName || '',
        withdrawalStatusCd: dto.memberWithdrawalStatusCd || '',
        withdrawalStatusCdName: dto.memberWithdrawalStatusCdName || '',
        withdrawalReqDate,
        withdrawalReqDateTime,
        balAmt: dto.balAmt ?? 0,
        balAmtFormatted: formatAmount(dto.balAmt),
        unpaidAmt: dto.unpaidAmt ?? 0,
        unpaidAmtFormatted: formatAmount(dto.unpaidAmt),
    };
};

export const withdrawRequestListFromDto = (response: GetWithdrawRequestListResponseDto): WithdrawRequest[] => {
    if (!response?.withdrawalList || !Array.isArray(response.withdrawalList)) return [];
    return response.withdrawalList.map((dto, index) => withdrawRequestFromDto(dto, index));
};
